<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/20CH/20CH.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">20通道DSP功放</div>
                <div class="detail-banner-desc">
                    20通道功放在12CH平台产品基础上，性能表现进一步升级：支持A2B级联Booster扩展输出通道；搭载电源智能追踪技术（TPS），可以提高效率约30%，减少散热；<br />
                    音效功能实现上，20通道功放还支持3D虚拟环绕、4D影院模式、7.1.4全景声、RNAC路噪控制、虚拟场景、头枕环绕等。
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">产品说明</div>
                    <div class="detail-desc">
                        <div>
                            自研产品，完整的设计及开发团队，成熟可靠的量产化方案<br />
                        </div>
                        <div>
                            高功率输出，额定功率1220W，可输出20个通道，支持27个扬声器<br />
                        </div>
                        <div>
                            高性能音频处理能力，豪华级音效和功能实现
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/20CH/20CH-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">236*148*42</div>
                                    <div class="k">尺寸（mm）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1405</div>
                                    <div class="k">重量（g）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1220W</div>
                                    <div class="k">额定功率</div>
                                </div> 
                                <div class="spec-item">
                                    <div class="v">&gt90dB</div>
                                    <div class="k">信噪比</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">&lt0.03%</div>
                                    <div class="k">总谐波失真+噪声</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Amor Space®虚拟场景</div>
                                    <div class="k">音效功能</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">立体声，Amor TruLogic® 2D&3D环绕，多种音效模式体验，Amor Pano® 7.1.4全景声</div>
                                    <div class="k">音效功能</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Amor Max Immersion®4D座椅律动</div>
                                    <div class="k">音效功能</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">iESE模拟声浪，ENAC发动机降噪，RNAC路噪控制，DNC动态速度补偿</div>
                                    <div class="k">音效功能</div>
                                </div>
                                

                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/20CH/20CH-1.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '20通道DSP功放 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'electronics/20CH.html'
};

import { createApp } from 'vue';
import App from './20CH.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./20CH.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
